import PaymentService from 'services/PaymentService';

export const fetchUserBalances = async () => {
  return PaymentService.getBalances().call();
};
